import ImageFuture from "next/image";
import { defaultLoader } from "utils/cloudinaryUtils";

const SoldVehicleImage = ({ companyName }: { companyName: string }) => {
    return (
        <div className="soldvehicleimg">
            <ImageFuture
                loader={defaultLoader}
                className="img-responsive"
                src="/static/images/soldvehicle.png"
                alt={`${companyName} sold vehicle`}
                height={100}
                width={200}
                loading="lazy"
            />
        </div>
    );
};

export default SoldVehicleImage;
